/**
 * Created by Daniela on 12/09/2016.
 */
export class ContaContabil {
  ativo: boolean; 
  descricao: string; 
  tipoId: number; 
  dataCriacao: string; 
  dataUltimaAlteracao: string; 
  descricaoAnalitica: boolean; 
  codigo: string; 
  paiId: number; 
  id: number; 
  usuarioCriacaoId: number; 
  usuarioUltimaAlteracaoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/shared/conta-contabil.model.ts
 **/